(ns motorsaif.web.admin.requests
  (:require
   [motorsaif.web.components :as c]
   [motorsaif.string :refer [format]]
   [motorsaif.utils :as utils]
   [motorsaif.web.components.tabular :as tabular]
   [motorsaif.time :as time]
   [motorsaif.frontend-routes :as routes]
   [re-frame.core :as rf :refer [subscribe]]
   [reagent.core :as r]))

(defn root []
  (let [requests @(subscribe [:admin-data :requests])
        data (map (fn [req]
                    (let [handle (utils/owner-handle (:owner req))
                          {id :db/id
                           date :date-time/created
                           coords :request/coords
                           {:car/keys [make model year]} :request/object} req
                          car (format "%s %s %s" year make model)
                          [lon lat] coords
                          posted (time/default-ago-str-date date)
                          {:keys [total-msgs
                                  unique-business-seen
                                  unique-responders-with-last-sent]} @(subscribe [:admin-data :requests-extended id])
                          last-sents (reverse (sort-by first unique-responders-with-last-sent))
                          visible [{:title "Posted"
                                    :val posted}
                                   {:title "Posted By"
                                    :val handle}
                                   {:title "Car"
                                    :val car}
                                   {:title "Last User Login"
                                    :val posted}
                                   {:title "Businesses Seen"
                                    :val (count unique-business-seen)}
                                   {:title "Total Messages"
                                    :val total-msgs}
                                   {:title "Unique Responders"
                                    :val (count unique-responders-with-last-sent)
                                    }
                                   ]
                          hidden [(fn []
                                    [:div
                                     (when (seq unique-business-seen)
                                       [:div
                                        [:h5 "Businesses Seen"]
                                        (into [:ul]
                                              (map (fn [[touched user biz]]
                                                     (let [{date :touched/last-access} touched
                                                           {:user/keys [handle]} user
                                                           {:business/keys [name]} biz
                                                           date (time/default-ago-str-date date)]
                                                       [:li
                                                        name
                                                        [:ul
                                                         [:li date]
                                                         [:li handle]]]))
                                                   unique-business-seen))])
                                     (when (seq last-sents)
                                       [:div
                                        [:h5 "Last Responses"]
                                        (into [:ul]
                                              (map (fn [{:keys [body date from]}]
                                                     [:li
                                                      [:span.bold
                                                       (format "%s - %s: "
                                                               (utils/owner-handle from)
                                                               (time/ago-str date)
                                                               )]
                                                      [:br] body])
                                                   last-sents))])
                                     [:a.btn.primary.small {:href
                                                            (routes/path-for :request {:id id})
                                                            } "View"]
                                     " "
                                     [:a.btn.primary.small {:href
                                                            (routes/path-for :edit-request {:id id})} "Edit"]

                                     [:div
                                      "Map"
                                      (when coords
                                        [:div
                                         [:div.map-link
                                          [:a
                                           {:href (format " https://www.google.com/maps/search/?api=1&query=%s&zoom=8"
                                                          (format "%s,%s" lat lon))
                                            :target "_blank"}
                                           "Open in google maps"]]
                                         [c/map-image coords]])]
                                     ])]]
                      {:visible visible
                       :hidden hidden}))
                  (reverse (sort-by :date-time/created requests)))]
    [:div.content.container
     [tabular/table data]]))
